export default {
  // task-eva-components
  "--task-eva-text-color-1": "#E0EDEF",
  "--task-eva-drawer-color-bg-mask": "rgba(0, 0, 0, 0.45)",
  "--task-eva-drawer-color-bg-header": "#18191B",
  "--task-eva-drawer-title-color": "#E0EDEF",
  "--task-eva-drawer-box-shadow-right":
    "-6px 0 16px 0 rgba(0, 0, 0, 0.08), -3px 0 6px -4px rgba(0, 0, 0, 0.12),-9px 0 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-box-shadow-left":
    "6px 0 16px 0 rgba(0, 0, 0, 0.08), 3px 0 6px -4px rgba(0, 0, 0, 0.12), 9px 0 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-box-shadow-top":
    "0 6px 16px 0 rgba(0, 0, 0, 0.08), 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-box-shadow-bottom":
    "0 -6px 16px 0 rgba(0, 0, 0, 0.08), 0 -3px 6px -4px rgba(0, 0, 0, 0.12), 0 -9px 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-drag-button-bg": "#45484D",
  // task-eva
  "--task-eva-color": "#384248",
  "--task-eva-sidebar": "#FFFFFF",
  "--task-eva-sidebar-color": "#384248",
  "--task-eva-sidebar-color-active": "#384248",
  "--task-eva-sidebar-item": "#EBEEF3",
  "--task-eva-sidebar-item-gap": "#E6EAF1",
  "--task-eva-header": "#FFFFFF",
  "--task-eva-header-color": "#384248",
  "--task-eva-header-color": "#384248",
  "--task-eva-header-color-active": "#384248",
  "--task-eva-header-shadow": "0px 4px 10px rgba(8, 53, 79, 0.19)",
  "--task-eva-platform-select-color": "#384248",
  "--task-eva-platform-select-bg": "#EBEEF3",
  "--task-eva-platform-select-bg-active": "#EBEEF3",
  "--task-eva-platform-select-item-color": "#384248",
  "--task-eva-platform-select-item-hover": "#EBEEF3",
  "--task-eva-platform-select-title-gap": "#E6EAF1",
  "--task-eva-select-arrow": "#A7ACC0",
  "--task-eva-dropdown-content-bg": "#FFFFFF",
  "--task-eva-dropdown-content-border": "#FFFFFF",
  "--task-eva-dropdown-content-shadow": "0px 4px 20px rgba(0, 0, 0, 0.66)",
  "--task-eva-content-bg": "#F2F3F4",
  "--task-eva-toptip-bg": "#E6EAF5",
  "--task-eva-toptip": "#384248",
  "--task-eva-common-card-bg": "#FFFFFF",
  "--task-eva-common-card-border": "#E6EAF5",
  "--task-eva-common-inner-card-border": "#E6EAF5",
  "--task-eva-statistic-card-title": "#6A7780",
  "--task-eva-statistic-card-success": "#588FF7",
  "--task-eva-statistic-card-default": "#1E2024",
  "--task-eva-statistic-card-fail": "#DF3535",
  "--task-eva-pie-total": "#6A7780",
  "--task-eva-pie-linear-0": "#588FF7",
  "--task-eva-pie-linear-1": "#58DAF7",
  "--task-eva-pie-left": "#E5E7EB",
  "--task-eva-line-chart-line": "#D4DBE9",
  "--task-link-color": "#588FF7",
  "--task-eva-search-bg": "#FFFFFF",
  "--task-eva-search-color": "var(--task-eva-color)",
  "--task-eva-search-placeholder": "#AABAC0",
  "--task-eva-search-border-focus": "#588FF7",
  "--task-eva-search-border": "#CFD7E3",
  "--task-eva-modal-bg": "#FFF",
  "--task-eva-modal-border": "#E6EAF5",
  "--task-eva-modal-close-icon": "#A6ACAF",
  "--task-eva-platform-modal-body-title": "var(--task-eva-color)",
  "--task-button-common-color": "var(--task-link-color)",
  "--task-eva-storage-modal-header": "#E6EAF5",
  "--task-eva-storage-modal-header-text": "#636770",
  "--task-eva-storage-modal-title-size": "16px",
  "--task-eva-storage-modal-body-text-size": "12px",
  "--task-eva-storage-modal-body-text": "#6A7780",
  "--task-eva-storage-modal-gap": "#E6EAF1",
  "--task-eva-storage-modal-title-border": "transparent",
  "--task-button-link-hover": "#f0f0f0",
  "--task-text-color": "var(--task-link-color)",
  "--task-eva-tooltip-light-bg": "rgba(255, 255, 255, 0.1)",
  "--task-eva-tooltip-light-color": "rgb(0, 0, 0)",
  "--task-eva-tooltip-dark-bg": "#FFF",
  "--task-eva-tooltip-dark-color": "var(--task-eva-color)",
  "--task-eva-filter-condition-border": "#d9ecff",
  // old
  "--content-background": "#F0F0F0",
  "--color-333": "#333",
  "--color-666": "#666",
  "--color-grey-light": "#f0f0f0",
  "--color-grey-heavy": "#ddd",
  "--color-grey-dark": "#cecdcd",
  "--common-hover-color": "#EAF2FF",
  "--main-background": "#FFFFFF",
  "--background-normal": "#F0F0F0",
  "--fill-tree-active": "#d28383",
  "--font-color-main": "#4A8EFF",
  "--main-color": "var(--font-color-main)",
  "--frames-color": "var(--main-color)",
  "--dialog-header-color": "#fff",
  "--dialog-title-color": "#333",
  "--render-layer-label-color": "#666",
  "--common-font-color": "#333",
  "--header-icon-bg": "#FFFFFF",
  "--header-icon-color": "#000",
  "--platform-bg": "#fff",
  "--platform-color": "4A8EFF",
  "--platform-list-color": "4A8EFF",
  "--platform-dropdown-bg": "#F4F4F4",
  "--sidebar-hover-background": "#EAF2FF",
  "--sidebar-hover-color": "#4A8EFF",
  "--index-hover": "#4A8EFF",
  "--overview-text-color1": "#4A8EFF",
  "--overview-text-color2": "#333",
  "--overview-text-color3": "#666",
  "--overview-border-color": "#DDDDDD",
  "--overview-title": "#666",
  "--button-bg": "#4A8EFF",
  "--soft-bg": "#EAF2FF",
  "--soft-side-bar-bg": "#fff",
  "--green-blue-match": "#4A8EFF",
};
